import { get, post, put } from '../lib/apiClient';

/** GET /users/{userId} */
export const getUser = (userId) => get(`/users/${encodeURIComponent(userId)}`);

/** PUT /users/{userId} — profile updates */
export const updateUser = (userId, updates) =>
  put(`/users/${encodeURIComponent(userId)}`, updates);

/** PUT /users/{userId}/password — { currentPassword, newPassword } */
export const changePassword = (userId, payload) =>
  put(`/users/${encodeURIComponent(userId)}/password`, payload);

/** GET /users/lookup?emailPrefix=... — any authenticated user */
export const lookupUsers = (emailPrefix) =>
  get('/users/lookup', { query: { emailPrefix } });

/** PUT /users/me/privacy — update caller's privacy settings */
export const updatePrivacySettings = (settings) =>
  put('/users/me/privacy', settings);

/**
 * POST /users/{userId}/emails/secondary/verify — { email, token }, all three
 * values coming from the emailed link.
 *
 * Public: no session required. The recipient of the verification email may not
 * be signed in, and the token delivered to that inbox is itself the proof of
 * ownership. userId is in the path because the handler resolves the account
 * with findUserById — there is no index on secondaryEmails, so the address
 * alone cannot find it.
 */
export const verifySecondaryEmail = (userId, email, token) =>
  post(`/users/${encodeURIComponent(userId)}/emails/secondary/verify`, { email, token }, {
    auth: false
  });
